<template>
  <v-row>
    <v-col>
      <v-select
        :value="startTime"
        :items="hourItems"
        :item-disabled="disableStartTimeItem"
        label="Start Time"
        :error="!!(errors && errors.startTime)"
        :error-messages="errors && errors.startTime"
        @change="updateStartTime"
      />
    </v-col>
    <v-col>
      <v-select
        :value="endTime"
        :items="hourItems"
        :item-disabled="disableEndTimeItem"
        label="End Time"
        :error="!!(errors && errors.endTime)"
        :error-messages="errors && errors.endTime"
        @change="updateEndTime"
      />
    </v-col>
    <v-col>
      <v-select
        :value="NRS"
        :items="NRSItems"
        label="Send alert at:"
        @change="updateNRS"
      />
    </v-col>
    <v-col cols="1">
      <v-btn
        icon
        @click="$emit('remove-threshold')"
      >
        <v-icon>$faTimes</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

  export default {
    name: 'EditActivityZoneThresholds',
    props: {
      startTime: Number,
      endTime: Number,
      NRS: Number,
      errors: Object,
    },
    computed: {
      hourItems () {
        return Array.from({ length: 24 }, (_, i) => ({
          value: i,
          text: i === 0 ? '12:00AM' : i === 12 ? '12:00PM' : i > 12 ? `${i - 12}:00PM` : `${i}:00AM`,
        }))
      },
      NRSItems () {
        return Array.from({ length: 20 }, (_, i) => ({
          value: 5 * i,
          text: `${5 * i} NRS`,
        }))
      },
    },
    methods: {
      disableStartTimeItem (item) {
        // disable item option if the item value is later than the endTime
        // except if the endTime is midnight
        if (this.endTime !== null) {
          if (this.endTime !== 0) {
            return item.value >= this.endTime
          }
          return item.value === 0
        }
        return false
      },
      disableEndTimeItem (item) {
        // disable item option if the item value is earlier than the startTime
        // except if the item value is midnight
        if (this.startTime !== null) {
          if (item.value <= this.startTime) {
            return item.value !== 0
          }
        }
        return false
      },
      updateStartTime (evt) {
        this.$emit('update:startTime', evt)
        this.$emit('touched')
      },
      updateEndTime (evt) {
        this.$emit('update:endTime', evt)
        this.$emit('touched')
      },
      updateNRS (evt) {
        this.$emit('update:NRS', evt)
        this.$emit('touched')
      },
    },
  }
</script>
